<div class="p-3 bg-gray">
  <div class="row">
    <div class="col-md-6 col-12 position-relative">
      <label for="Usertype" class="fs-14 fw-normal font-white">Select region</label>
      <select
        class="form-select bg-form-control border-0 font-white w-100 pe-5 custom-select"
        [(ngModel)]="cityList.RegionID"
        name="UserTypeID"
        [ngModelOptions]="{ standalone: true }"
        (focus)="isUserTypeDropdownOpen = true"
        (blur)="isUserTypeDropdownOpen = false">
        <option *ngFor="let region of regionList" [value]="region.RegionID">
          {{ region.RegionName }}
        </option>
      </select>

      <div class="custom-select-arrow" [ngClass]="{ 'rotate-arrow': isUserTypeDropdownOpen }">▼</div>
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="CityName" class="fs-14 fw-normal font-white">City Name</label>
      <input class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="cityList.CityName" name="CityName" placeholder="City Name" />
    </div>
    <div class="col-12 mt-5 d-flex justify-content-end">
      <button class="btn btn-success border-radius-10" (click)="onSubmit()">Add</button>
    </div>
  </div>
</div>
